export default __webpack_public_path__ + "static/media/icon-relacao-mensal-venda.20c98f06.svg";